import { Injectable, inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Analytics, logEvent } from '@angular/fire/analytics';
import { filter } from 'rxjs/operators';

// Declarar gtag para TypeScript
declare let gtag: Function;

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  private analytics = inject(Analytics);
  private router = inject(Router);

  constructor() {
    this.initializeRouteTracking();
  }

  private initializeRouteTracking() {
    // Escuchar todos los cambios de ruta
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.trackPageView(event.urlAfterRedirects);
      });
  }

  trackPageView(url: string) {
    try {
      // Usando Firebase Analytics
      logEvent(this.analytics, 'page_view', {
        page_location: window.location.href,
        page_path: url,
        page_title: document.title,
      });

      // Usando gtag directamente (más compatible)
      if (typeof gtag !== 'undefined') {
        gtag('config', 'G-X30K5R2DK2', {
          page_path: url,
          page_title: document.title,
          page_location: window.location.href,
        });
      }

    } catch (error) {
      console.error('Error tracking page view:', error);
    }
  }

  // Método para trackear eventos personalizados
  trackEvent(eventName: string, parameters?: any) {
    try {
      // Firebase Analytics
      logEvent(this.analytics, eventName, parameters);

      // gtag
      if (typeof gtag !== 'undefined') {
        gtag('event', eventName, parameters);
      }

    } catch (error) {
      console.error('Error tracking event:', error);
    }
  }

  // Trackear interacciones específicas
  trackButtonClick(buttonName: string, location?: string) {
    this.trackEvent('click', {
      event_category: 'engagement',
      event_label: buttonName,
      page_location: location || window.location.pathname,
    });
  }

  trackModalOpen(modalName: string) {
    this.trackEvent('modal_open', {
      event_category: 'engagement',
      modal_name: modalName,
    });
  }

  trackModalClose(modalName: string) {
    this.trackEvent('modal_close', {
      event_category: 'engagement',
      modal_name: modalName,
    });
  }

  trackSearch(searchTerm: string) {
    this.trackEvent('search', {
      search_term: searchTerm,
    });
  }

  trackArtistView(artistId: string, artistName?: string) {
    this.trackEvent('view_item', {
      item_id: artistId,
      item_name: artistName,
      item_category: 'artist',
    });
  }

  trackWorkOfArtView(workId: string, workTitle?: string, artistName?: string) {
    this.trackEvent('view_item', {
      item_id: workId,
      item_name: workTitle,
      item_category: 'artwork',
      artist_name: artistName,
    });
  }
}
